<template>
  <label class="input-container" :class="{error: error && error.length > 0}">
    <span v-if="label" class="input-label">{{ label }}</span>
    <textarea :value="value" @change="update($event.target.value)" v-bind="$attrs"
           class="input textarea"  :placeholder="placeholder">
      </textarea>
    <transition name="fade">
      <p v-if="error && error.length > 0" class="input-error">{{ error }}</p>
    </transition>
  </label>
</template>

<script>
export default {
  name: "ATextArea",
  props: {
    label: String,
    placeholder: {
      type: String,
      default() {
        return 'Enter...'
      }
    },
    error: String,
    value: [String, Number],
  },
  methods: {
    update(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style scoped>

</style>
